import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardFooter, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const burgers = [{
  id: 1,
  name: "Claypot Bonito Chicken Set",
  chineseName: "大台北 柴鱼鸡煲套餐",
  price: "$12.80",
  description: "Our signature bubbling claypot featuring tender chicken chunks and aromatic bonito flakes in a savory broth.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1540096/img/claypot_chicken.png",
  link: "/GreatTaipeiPage"
}, {
  id: 2,
  name: "Popcorn Chicken Set",
  chineseName: "大台北盐酥鸡套餐",
  price: "$10.50",
  description: "Crispy, golden-fried Taiwanese popcorn chicken seasoned with our secret five-spice salt and fresh basil.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1540096/img/popcorn_chicken.png",
  link: "/GreatTaipeiPage"
}, {
  id: 3,
  name: "Braised Pork Rice Set",
  chineseName: "大台北招牌卤肉饭套餐",
  price: "$9.80",
  description: "Melt-in-your-mouth braised pork belly served over premium steamed rice with a soy-marinated egg.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1540096/img/braised_pork.png",
  link: "/GreatTaipeiPage"
}];
export default function TheLineup() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="33133" id="taiwanese-signatures" ref={ref} className={`bg-background text-foreground py-24 px-4 overflow-visible relative transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--accent)_0%,_transparent_40%)] opacity-10 pointer-events-none blur-3xl" />

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-black tracking-tighter mb-4 text-foreground uppercase">
            Taiwanese Signatures
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg font-medium">
            Authentic Taipei street food flavors, crafted for the fast-paced modern palate.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-y-20 gap-x-8 pt-12">
          {burgers.map((burger, i) => <div key={burger.id} data-index={i} className="group relative">
              <Card className="bg-card border-border/50 overflow-visible h-full hover:-translate-y-2 transition-all duration-500 shadow-xl hover:shadow-2xl rounded-xl">
                {}
                <div className="relative -mt-24 mx-auto w-48 h-48 flex items-center justify-center">
                  {}
                  <div className="absolute inset-0 bg-primary/10 blur-[40px] rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500 scale-125" />
                  
                  <img src={burger.image} alt={burger.name} className="w-full h-full object-contain drop-shadow-xl relative z-10 transform group-hover:scale-105 transition-transform duration-500 rounded-xl" />
                </div>

                <CardHeader className="text-center pt-6 pb-2">
                  <CardTitle className="text-2xl font-black text-foreground mb-1 font-sans">
                    {burger.name}
                  </CardTitle>
                  <div className="text-secondary text-lg font-bold tracking-tight mb-2">
                    {burger.chineseName}
                  </div>
                </CardHeader>

                <CardContent className="text-center pb-6">
                  <CardDescription className="text-muted-foreground leading-relaxed font-medium">
                    <span className="text-primary font-mono font-bold block mb-2 text-xl">{burger.price}</span>
                    {burger.description}
                  </CardDescription>
                </CardContent>

                <CardFooter className="flex justify-center pb-8">
                  <Button asChild variant="link" className="text-foreground hover:text-primary transition-colors p-0 h-auto font-bold group/btn uppercase tracking-wider">
                    <Link to={burger.link}>
                      Order Now
                      <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover/btn:translate-x-1" />
                    </Link>
                  </Button>
                </CardFooter>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}